import { ScaleType, Tag, Cause, Measure, Context, BranchArea } from "@/types";

export interface Risk {
  id?: number;
  name: string;
  description?: string;
  probability: number;
  branch_area_id: number | null;
  context_id?: number;
  risk_status: RiskStatus | null;
  category?: RiskCategory | null;

  financial_consequence?: string;
  financial_min_value?: number;
  financial_mode_value: number | null;
  financial_max_value: number;

  image_consequence?: string;
  image_value?: ScaleType;
  time_consequence?: string;
  time_value?: ScaleType;
  environment_consequence?: string;
  environment_value?: ScaleType;
  safety_consequence?: string;
  safety_value?: ScaleType;
  objective_consequence?: string;
  objective_value?: ScaleType;

  context?: Context;
  causes?: Cause[];
  measures?: Measure[];
  risk_tags?: [{ tags: Tag }] | []; // * to * behaviour
  branch_area?: BranchArea;

  sensitivityScore?: number;
  netConsequence?: number;
  grossConsequence?: number;
  netProbability?: number;
  probabilityCovered?: number;
  grossRisk?: number;
  netRisk?: number;
  temp_index?: number;
}

export interface MonteCarloSimulationInput {
  id: number;
  name: string;
  probability: number;
  financial_min_value: number;
  financial_max_value: number;
  financial_mode_value?: number;
}

export const ConsequenceTypes = {
  Financial: "financial",
  Image: "image",
  Time: "time",
  Environment: "environment",
  Safety: "safety",
  Objective: "objective",
} as const;

export type ConsequenceType =
  (typeof ConsequenceTypes)[keyof typeof ConsequenceTypes];

export const RiskStatuses = {
  Brainstorm: "brainstorm",
  Pending: "pending",
  Review: "review",
  Approved: "approved",
} as const;

export type RiskStatus = (typeof RiskStatuses)[keyof typeof RiskStatuses];

export const RiskCategories = {
  FinancialEconomic: "financial_economic",
  LegalCompliance: "legal_compliance",
  ManagementOrganisation: "management_organisation",
  PoliticalAdministrative: "political_administrative",
  QualityResult: "quality_result",
  SafetyEnvironment: "safety_environment",
  ItCyber: "it_cyber",
  GeographicEnvironment: "geographic_environment",
  Technical: "technical",
} as const;

export type RiskCategory = (typeof RiskCategories)[keyof typeof RiskCategories];
